import { Component, OnInit, signal } from '@angular/core';
import { User } from 'app/classes/user';
import { APIService } from 'app/shared/api.service';
import { WindowService } from 'app/shared/window.service';

@Component({
  selector: 'app-org-contacts-home',
  templateUrl: './org-contacts-home.component.html',
  styleUrls: ['./org-contacts-home.component.css'],
  standalone: false
})
export class OrgContactsHomeComponent implements OnInit {

  isShowingDialog = signal<boolean>(false);
  isLoading = signal<boolean>(false);
  contacts = signal<any[]>(null);
  contact = signal<User>(null);

  constructor(private apiService: APIService, private windowService: WindowService) {

  }

  ngOnInit(): void {
    this.get();
  }

  get() {
    this.isLoading.set(true);
    this.apiService.getUsersForOrg('a=contacts').then(
      users => {
        this.contacts.set(users.filter(u => u.role === 'contact'));
        this.isLoading.set(false);
      }
    );
  }

  editContact(contact: User) {
    this.contact.set(contact);
    this.isShowingDialog.set(true);
  }

  createContact() {
    this.isShowingDialog.set(true);
    this.contact.set(new User());
  }

  hasSaved(contact: any) {
    this.isShowingDialog.set(false);
    if (contact) {
      this.apiService.toastSuccess('Updated contact');
      this.get();
    }
  }

  hasDeleted(contact: any) {
    this.apiService.toastSuccess('Deleted contact');
    this.isShowingDialog.set(false);
    this.get();
  }

  hasClosed() {
    this.isShowingDialog.set(false);
  }
}
